import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const lineVar = { hidden: { y: "105%" }, show: (i) => ({ y: 0, transition: { duration: 1.1, ease: EASE, delay: i } }) };

export const LineReveal = ({ lines, className = "", delay = 0, onLoad = false }) => (
  <motion.span className={`block ${className}`} initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}>
    {lines.map((line, i) => (
      <span key={i} className="block pb-[0.08em]" style={{ clipPath: "inset(-60% -15% 0 -15%)" }}>
        <motion.span className="block" variants={lineVar} custom={delay + i * 0.12}>{line}</motion.span>
      </span>
    ))}
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} {...rest}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE, delay }}>
      {children}
    </M>
  );
};

export const CountUp = ({ value, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(value);
  useEffect(() => {
    if (!inView) return undefined;
    const ctrl = animate(0, value, { duration: 2, ease: EASE, onUpdate: (v) => setN(Math.round(v)) });
    return () => ctrl.stop();
  }, [inView, value]);
  return <span ref={ref}>{n.toLocaleString("en-IN")}{suffix}</span>;
};

export const SectionHead = ({ eyebrow, title, text, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <FadeUp><p className="eyebrow mb-5">{eyebrow}</p></FadeUp>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
      <LineReveal lines={Array.isArray(title) ? title : [title]} />
    </h2>
    {text && <FadeUp delay={0.15}><p className="mt-6 text-base md:text-lg text-[#a5b4c8] leading-relaxed">{text}</p></FadeUp>}
  </div>
);
